import { render, staticRenderFns } from "./LaravelVuePagination.vue?vue&type=template&id=4b57b2a3"
import script from "./LaravelVuePagination.vue?vue&type=script&lang=js"
export * from "./LaravelVuePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports